/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboPostaveniSubjektu;
(function (EnumZboPostaveniSubjektu) {
    EnumZboPostaveniSubjektu["PODATEL"] = "PODATEL";
    EnumZboPostaveniSubjektu["ZADATEL"] = "ZADATEL";
    EnumZboPostaveniSubjektu["ZHOTOVITEL"] = "ZHOTOVITEL";
    EnumZboPostaveniSubjektu["INVESTOR"] = "INVESTOR";
    EnumZboPostaveniSubjektu["ZASTUPCE"] = "ZASTUPCE";
    EnumZboPostaveniSubjektu["KONTAKT"] = "KONTAKT";
    EnumZboPostaveniSubjektu["PODEPISUJICI"] = "PODEPISUJICI";
    EnumZboPostaveniSubjektu["ZODPOVEDNY"] = "ZODPOVEDNY";
    EnumZboPostaveniSubjektu["NAJEMCE"] = "NAJEMCE";
    EnumZboPostaveniSubjektu["PRONAJIMATEL"] = "PRONAJIMATEL";
})(EnumZboPostaveniSubjektu || (EnumZboPostaveniSubjektu = {}));
//# sourceMappingURL=enum-zbo-postaveni-subjektu.js.map